var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMergeVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM6.84483 8.80474L9.81983 11.6381C10.0267 11.8351 10.0267 12.1652 9.81983 12.3622L6.84483 15.1955C6.5265 15.4987 6 15.2731 6 14.8335V9.16681C6 8.72721 6.5265 8.50157 6.84483 8.80474ZM17.1552 8.80474C17.4735 8.50157 18 8.72721 18 9.16681V14.8335C18 15.2731 17.4735 15.4987 17.1552 15.1955L14.1802 12.3622C13.9733 12.1652 13.9733 11.8351 14.1802 11.6381L17.1552 8.80474ZM12 16.1787C11.5858 16.1787 11.25 15.8429 11.25 15.4287V8.57157C11.25 8.15735 11.5858 7.82157 12 7.82157C12.4142 7.82157 12.75 8.15735 12.75 8.57157V15.4287C12.75 15.8429 12.4142 16.1787 12 16.1787Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeVertical);
export default __webpack_public_path__ + "static/media/merge-vertical.cdecc37e3b29bd305f58bd1cb65a48de.svg";
export { ForwardRef as ReactComponent };